import { z } from 'zod'
import {
	baseMapDeploymentSchema,
	type ServerReceivedMapDeployments,
} from '@/features/filteredMap/mapDeployments/models'
// import marketviewAssetsDemand from '../marketview-assets-demand.json'

export const demandInstanceSchema = baseMapDeploymentSchema.extend({
	organisation: z.string(), // name of the enterprise
	sector: z.string(), // sector of the enterprise e.g Automotive
	api: z.string(), // API name
	webLink: z.nullable(z.string()), // web link to a “Further information” page. Can be null.
})

export type DemandMapDeployment = z.infer<typeof demandInstanceSchema>
export type ServerReceivedDemandMapDeployment =
	ServerReceivedMapDeployments<DemandMapDeployment>

import type { ValidateMapDeploymentsResult } from '@/features/filteredMap/mapDeployments/fetchMapDeployments'
import { serverReceivedMapDeploymentsSchema } from '@/features/filteredMap/mapDeployments/models'

export function validateServerReceivedDemandMapDeployment(
	unvalidatedData: ServerReceivedMapDeployments<DemandMapDeployment>
): ValidateMapDeploymentsResult<DemandMapDeployment> {
	const { data, error } =
		serverReceivedMapDeploymentsSchema(demandInstanceSchema).safeParse(
			unvalidatedData
		)
	if (error) {
		const pretty = z.prettifyError(error)

		// console.log('validation of DemandMapDeployments was NOT successful')
		return {
			success: false,
			message: `Error parsing ServerReceivedDemandMapDeployment: ${pretty}`,
		}
	}
	// console.log('validation of DemandMapDeployments was successful')
	return {
		success: true,
		data,
	}
}
